import { render, staticRenderFns } from "./RewardCenterResource.vue?vue&type=template&id=486b6e50&scoped=true"
import script from "./RewardCenterResource.vue?vue&type=script&lang=js"
export * from "./RewardCenterResource.vue?vue&type=script&lang=js"
import style0 from "./RewardCenterResource.vue?vue&type=style&index=0&id=486b6e50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486b6e50",
  null
  
)

export default component.exports